<template>
  <div class="loading-center" :class="{'loading-center-hight':heightList.indexOf(type)!=-1}">
    <div v-if="type=='export'">
      <img src="../../assets/images/batch/export.svg" class="export" v-if="!HQ">
      <img src="../../assets/images/batch/hq_export.png" class="export" v-else>
      <div class="tips export">
        <p class="title">正在生成导出文件... </p>
        <p class="content">成功后可以前往右上方“导出记录”处下载，<br/>请耐心等待。期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='download'">
      <img src="../../assets/images/batch/export.svg"  class="export"  v-if="!HQ">
      <img src="../../assets/images/batch/hq_export.png" class="export"  v-else>
      <div class="tips export">
        <p class="title">正在生成下载文件... </p>
        <p class="content">成功后可以前往右上方“导出记录”处下载，请耐心等待。期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='delete'">
      <img src="../../assets/images/batch/delete.png" class="delete" v-if="!HQ">
      <img src="../../assets/images/batch/hq_delete.png" class="delete" v-else>
      <div class="tips deletes">
        <p class="title">正在删除... </p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='add'">
      <img src="../../assets/images/batch/add.svg"  class="add" v-if="!HQ">
      <img src="../../assets/images/batch/hq_add.png"  class="add" v-else>
      <div class="tips">
        <p class="title">正在添加...  </p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='task'">
      <img src="../../assets/images/batch/task.svg" class="task" v-if="!HQ">
      <img src="../../assets/images/batch/hq_task.png" class="task" v-else>
      <div class="tips">
        <p class="title">正在分配任务...</p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='robot'">
      <img src="../../assets/images/batch/robot.png" class="robot" v-if="!HQ">
      <img src="../../assets/images/batch/hq_robot.png" class="robot" v-else>
      <div class="tips">
        <p class="title">正在导入{{robot.name}}...</p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='sync'">
      <img src="../../assets/images/batch/sync.svg" class="robot">
      <div class="tips">
        <p class="title">正在同步...</p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='recover'">
      <img src="../../assets/images/batch/recovers.svg" class="recover">
      <div class="tips">
        <p class="title">正在释放数据...</p>
        <p class="content">预计将持续10～20s，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='other'">
      <img src="../../assets/images/batch/wait.svg" class="others" v-if="!HQ">
      <img src="../../assets/images/batch/hq_wait.png" class="others" v-else>
      <div class="tips other">
        <p class="content">此板块正在执行任务, 请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='otherSea'">
      <img src="../../assets/images/batch/wait.svg" class="others" v-if="!HQ">
      <img src="../../assets/images/batch/hq_wait.png" class="others" v-else>
      <div class="tips other">
        <p class="content">此{{getPublicName()}}正在执行任务, 请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
    <div v-if="type=='createSea'">
      <img src="../../assets/images/batch/createSea.svg" class="creates" v-if="!HQ">
      <img src="../../assets/images/batch/hq_createSea.png" class="creates" v-else>
      <div class="tips create">
        <p class="content">正在创建{{getPublicName()}}，请耐心等待</p>
      </div>
    </div>
    <div v-if="type=='updateSea'">
      <img src="../../assets/images/batch/updateSea.svg"  class="creates" v-if="!HQ">
      <img src="../../assets/images/batch/hq_updateSea.png" class="creates" v-else>
      <div class="tips create">
        <p class="content">正在更新{{getPublicName()}}，请耐心等待</p>
      </div>
    </div>
    <div v-if="type=='diverting'">
      <img src="../../assets/images/batch/sync.svg"  class="divertimg">
      <div class="tips">
        <p class="title">正在转移数据... </p>
        <p class="content">预计将持续 10~20s，请耐心等待。<br/>期间您可以正常使用其他功能</p>
      </div>
    </div>
    <div v-if="type=='divert'">
      <img src="../../assets/images/batch/wait.svg" class="others divert-other" v-if="!HQ">
      <img src="../../assets/images/batch/hq_wait.png" class="others divert-other" v-else>
      <div class="tips other">
        <p class="content divert-content">有线索正在被转移，请耐心等待。<br/> 期间您可以正常使用其他功能。</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'export'
      },
      robot: {
        type: Object,
        default:function () {
          return {}
        }
      },
    },
    data() {
      return {
        heightList:['export','delete','add','robot','recover']
      };
    }
  };
</script>

<style lang="scss">
  .loading-center {
    position: fixed;
    width: 330px;
    height: 240px;
    background: #fff;
    border: 1px solid var(--contact-division-color);
    z-index: 9999;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    // padding: 20px;
    border-radius: 6px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    &.loading-center-hight{
      height: 280px;
    }
    img{
      margin: 58px auto 20px;
      display: block;
    }
    img.export{
      margin-top: 48px;
      width: 100px;
      height:72px;
    }
    img.delete{
      width: 62px;
      height:72px;
    }
    img.add{
      margin-top: 54px;

      width: 100px;
      height:72px;
    }
    img.task{
      margin-top: 54px;
      width: 56px;
      height:43px;
    }
    img.robot{
      margin-top: 54px;
      width: 99px;
      height:72px;
    }
    img.recover{
      width: 59px;
      height:72px;
    }
    img.others{
      width: 85px;
      height:45px;
    }
    img.creates{
      width:124px;
      height:84px;
    }
    img.divertimg{
      margin-top: 40px;
      width: 99px;
      height:72px;
    }
    img.divert-other{
      width: 63px;
      height:72px;
    }
    .tips{
      text-align: center;
      .title{
        color: #333;
        font-size: 20px;
        font-weight: 600;
        margin: 20px 0 15px;
      }
      .content{
        color: #999;
        font-size: 14px;
        line-height: 20px;
      }
      .divert-content{
        color: #333;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
      }
    }
    // .tips.export{
    //   margin-left: 160px;
    // }
    // .tips.deletes{
    //   margin-left: 160px;
    // }
    // .tips.other{
    //   padding-top: 40px;
    //   .content{
    //     color: #333;
    //     font-weight: 600;
    //     line-height: 22px;
    //   }
    // }
    .tips.create{
      .content{
        color: #333;
        font-weight: 600;
        line-height: 22px;
        
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/global/awaitTips.vue